import { ThemeOptions, createTheme } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
    spacing: 8, // Define the spacing unit (8px is the default)
    palette: {
        background: {
            default: '#ffffff'
        },
        primary: {
            main: "#0099CC",
        },
        secondary: {
            main: "#C8102E",
        },
    },
    typography: {
        fontFamily: 'sans-serif',
        fontSize: 13,
    },
    components: {
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    '@media (min-width: 600px)': {
                        minHeight: '56px'
                    }
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    paddingTop: '8px',
                    '&.Mui-selected, &:hover': {
                        backgroundColor: 'transparent',
                        color: '#0099CC',
                        fontWeight: 'bold',
                        '& div': {
                            backgroundColor: 'transparent',
                            color: '#0099CC',
                        },
                        '& p': {
                            backgroundColor: 'transparent',
                            color: '#0099CC',
                            fontWeight: 'bold',
                        }
                    }
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: '15px',
                    fontWeight: 'bold'
                },
                secondary: {
                    color: '#000000',
                    fontSize: '13px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'center'
                }
            }
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    color: '#808080',  //default color
                    '&.Mui-completed': {
                        color: '#4F758B',
                    },
                    '&.Mui-active': {
                        color: '#4F758B',
                    }
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    color: '#808080',  //default color
                    '&.Mui-completed': {
                        color: '#4F758B',
                        fontWeight: 'bold'
                    },
                    '&.Mui-active': {
                        color: '#000000',
                        fontWeight: 'bold'
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    "&.Mui-checked": {
                        "color": "#0099CC"
                    }
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                colorSecondary: {
                    "&.Mui-checked": {
                        "color": "#0099CC"
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: '#FFFFFF',
                    borderBottom: '3px solid #E0E0E0'
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: '#FFFFFF',
                    fontWeight: 'normal',
                    '&.Mui-selected': {
                        color: '#FFFFFF',
                        fontWeight: 'bold'
                    },
                    '&:hover': {
                        color: '#FFFFFF',
                        fontWeight: 'bold'
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0099CC',
                    color: '#FFFFFF',
                    fontWeight: 'normal',
                    '&.Mui-disabled': {
                        backgroundColor: '#D3D3D3',
                        color: '#707070',
                    },
                    '&:hover': {
                        backgroundColor: '#4F758B',
                        fontWeight: 'bold'
                    },
                },
                textPrimary: {
                    color: '#FFFFFF',
                    '&:hover': {
                        backgroundColor: '#4F758B',
                        color: '#FFFFFF',
                        fontWeight: 'bold'
                    },
                },
            }
        },
        MuiFab: {
            styleOverrides: {
                primary: {
                    '&:hover': {
                        backgroundColor: '#4F758B',
                        color: '#FFFFFF',
                        //fontWeight: 'bold'
                    }
                },
                secondary: {
                    '&:hover': {
                        backgroundColor: '#8c0b20',
                        color: '#FFFFFF',
                        //fontWeight: 'bold'
                    }
                },
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    margin: '0px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    fontSize: '0.8125rem',
                    fontFamily: 'sans-serif'
                },
                head: {
                    color: "#4F758B",
                    fontWeight: 'bold'
                },
                paddingNone: {
                    padding: 1,
                    '&:last-child': {
                        padding: 2
                    }
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    height: '34px'
                },
            }
        }
    }
}

const myNcqaTheme = createTheme(themeOptions);

export default myNcqaTheme;
